// Helper function to determine the current page name
export function determinePageName(): string | null {
  if (typeof window !== 'undefined') {
    return (window as any).currentPageName || '/';
  }
  
  console.log('Unable to determine page name');
  return null;
}
